import React from "react";
import { useForm, Controller } from "react-hook-form";
import { login } from "_services/oauth";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Email from "@material-ui/icons/Person";
import LockIcon from "@material-ui/icons/Lock";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardFooter from "components/Card/CardFooter.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";


import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';

import styles from "assets/jss/material-dashboard-react/views/loginPageStyle.js";

import provider_icon from "assets/img/provider_id.png";
import Do4Dont from "assets/img/4Do4Dont_OnePage.png";

const useStyles = makeStyles(styles);


const LoginPage = (props) => {
    const { location, ...other } = props;
    const user = useSelector((state) => state.auth.user);
    const history = useHistory();

    const [cardAnimaton, setCardAnimation] = React.useState("cardHidden");
    const { register, handleSubmit } = useForm();

    const [error, setError] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState("");
    const [snackColor, setSnackColor] = React.useState("danger");
    const [Status, setStatus] = React.useState(200);

    const [Username, setUserName] = React.useState("");
    const [Password, setPassword] = React.useState("");
    const [Action, setAction] = React.useState("");

    const [isForgot, setIsForgot] = React.useState(false);

    const dispatch = useDispatch();

    React.useEffect(() => {

        const queryParams = new URLSearchParams(window.location.search);
        setAction(queryParams.get("action"));


        if (user) {
            history.push("/datacenter/user-profile");
        }

        let id = setTimeout(function () {
            setCardAnimation("");
        }, 700);


        if (queryParams.get("error") != null) {
            setError(true);
            setErrMsg(queryParams.get("error"));
        }
            

        // Specify how to clean up after this effect:
        return function cleanup() {
            window.clearTimeout(id);
        };



    });
    const classes = useStyles();

    const showNotification = (place) => {
        switch (place) {
            case "tr":
                if (!error) {
                    setError(true);
                    setTimeout(function () {
                        setError(false);
                    }, 6000);
                }
                break;
            default:
                break;
        }
    };

    const doLogin = (data) => {
        login({ email: data.email, password: data.password })
            .then((token) => {
                console.log(token)


                if (token.data.success) {


                    if (Action !== null && Action === "telegram") {
                        window.location.href = 'https://t.me/SkinTrangBot?start=' + data.email;
                    }
                    else {
                        if (location.state != null && location.state.redirect != null && location.state.redirect != '')
                            history.push(location.state.redirect);
                        else
                            history.push("/home");
                    }


                } else {
                    setStatus(token.data.status);
                    setErrMsg(token.data.msg);
                    setSnackColor('danger');
                    showNotification("tr");
                }


            })
            .catch((error) => {
                console.log(error);
                setErrMsg('catch error');
                //  setSnackColor('danger')
                showNotification("tr");

            });
    };

    const onSubmit = (data) => {
        doLogin(data)
        /*
          login({ email: data.email, password: data.password })
          .then((token) => {
            console.log(token)
            if (token.data.status != 404 && token.data.status != 500) {
              history.push("/home");
            } else {
              setStatus(token.data.status);
              setErrMsg(token.data.msg);
              setSnackColor('danger')
              showNotification("tr");
            }
          })
          .catch((error) => {
            console.error(error);
            showNotification("tr");
          });
          */
    };

    const onMerge = () => {

        // (url,body)
        axios.post("/api/v1/identity/merge", { userName: Username, password: Password })
            .then(
                result => {
                    if (result.data.status == 200) {

                        setErrMsg(result.data.msg);
                        setSnackColor('success')
                        showNotification("tr");

                        doLogin({ email: Username, password: Password })
                    }
                    else if (result.data.status == 404) {
                        setErrMsg(result.data.msg);
                        setSnackColor('danger')
                        showNotification("tr");
                    }
                }, error => { console.log(error); }
            );


    };

    const onPreReset = () => {

        if (Username != "") {

            // (url,body)
            axios.post("/api/v1/identity/pre-reset", { userName: Username })
                .then(
                    result => {
                        console.log(result)
                        if (result.data.result == 200) {

                            setErrMsg(result.data.msg);
                            setSnackColor('success')
                            showNotification("tr");

                            setIsForgot(false);
                        }
                        else if (result.data.result == 404) {
                            setErrMsg(result.data.msg);
                            setSnackColor('danger')
                            showNotification("tr");
                        }
                    }, error => { console.log(error); }
                );
        }
        else {
            alert('กรุณากรอก Username')
        }



    };

    return (
        <div className={classes.container}>
            <GridContainer justify="center">
                  <GridItem xs={12} sm={12} md={6}>


                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Card login className={classes[cardAnimaton]}>
                            <CardHeader
                                className={`${classes.cardHeader} ${classes.textCenter}`}
                                color="rose"
                            >
                                <h4 className={classes.cardTitle}>ระบบ E-Service SKIN@Trang {Action}</h4>
                                <div className={classes.socialLine}>
                                    {[
                                        { icon: "fab fa-chrome", url: "http://www.trangskin.go.th" },
                                        { icon: "fab fa-facebook-square", url: "https://www.facebook.com/trangskin" },
                                        { icon: "fab fa-youtube-square", url: "https://www.youtube.com/@skintrang" },
                                    ].map((prop, key) => {
                                        return (
                                            <a href={prop.url} target='_blank'>
                                                <Button
                                                    color="transparent"
                                                    justIcon
                                                    key={key}
                                                    className={classes.customButtonClass}
                                                >
                                                    <i className={prop.icon} />
                                                </Button>
                                            </a>
                                        );
                                    })}
                                </div>
                            </CardHeader>

                            <CardBody>
                                <TextField
                                    inputRef={register}
                                    name="email"
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="Username"
                                    onChange={e => setUserName(e.target.value)}
                                />
                                <TextField
                                    inputRef={register}
                                    name="password"
                                    variant="outlined"
                                    margin="normal"
                                    required
                                    fullWidth
                                    label="Password"
                                    type="password"
                                    onChange={e => setPassword(e.target.value)}
                                    hidden={isForgot} 
                                />

                                <Grid xs={12} sm={12} md={12}>

                                    <FormControlLabel xs={12} sm={6} md={6}
                                        control={<Checkbox value="remember" color="primary" />}
                                        label="Remember me"
                                        hidden={isForgot}
                                    />

                                    <FormControlLabel xs={12} sm={6} md={6} style={{ float:'Right', paddingTop:'12px', fontSize:'16px'}}
                                        control={(isForgot == false) ?
                                            <Link color="info" size="lg" onClick={() => setIsForgot(true)}>
                                                Reset รหัสผ่าน
                                            </Link> : <></>
                                        }
                                        
                                    />

                                    <FormControlLabel xs={12} sm={6} md={6} style={{ float: 'Right', paddingTop: '12px', fontSize: '16px' }}
                                        control={(isForgot == true) ?
                                            <Link color="info" size="lg" onClick={() => setIsForgot(false)}>
                                                Login
                                            </Link> : <></>
                                        }

                                    />

                                </Grid>

                            </CardBody>

                            

                            <CardFooter className={classes.justifyContentCenter} >

                                <Grid container>
                                    <Grid xs={12} sm={12} md={12} hidden={isForgot}>
                                        <Button type="submit" color="rose" size="lg" block>
                                            Login
                                        </Button>
                                        {(Status == 404) ?
                                        <Button type="button" color="info" size="lg" block onClick={onMerge}>
                                            ดึงข้อมูลจาก Intranet
                                        </Button> : <></>
                                        }
                                    </Grid>

                                    <Grid xs={12} sm={12} md={12} hidden={!isForgot}>
                                        <Button type="button" color="rose" size="lg" block onClick={onPreReset}>
                                            ส่ง Link Reset รหัส
                                        </Button>                                   
                                    </Grid>

                                    <Grid xs={12} sm={12} md={12} hidden={isForgot}>
                                        {/*<Button type="button" color="white" size="lg" block onClick={() => window.location.href = "https://moph.id.th/oauth/redirect?client_id=01957f64-39ca-72a1-a052-d5c5b2c5ebf5&redirect_uri=https://e.trangskin.go.th/moph/redirect?state=eservice&response_type=code"}>*/}
                                        <Button type="button" color="white" size="lg" block onClick={() => window.location.href = "https://moph.id.th/oauth/redirect?client_id=01957f64-39ca-72a1-a052-d5c5b2c5ebf5&redirect_uri=https://e.trangskin.go.th/moph/redirect&response_type=code"}>
                                            <img src={provider_icon} style={{ height: "100%", maxHeight: "2.5rem", objectFit: "contain" }} />
                                        </Button>
                                    </Grid>

                                   
                                    <Grid xs={12} sm={12} md={12}>
                                        <Snackbar
                                            place="tr"
                                            color={snackColor}
                                            icon={AddAlert}
                                            message={errMsg}
                                            open={error}
                                            closeNotification={() => setError(false)}
                                            close
                                        />
                                    </Grid>
                                </Grid>

                              

                            </CardFooter>
                        </Card>
                    </form>
                </GridItem>

                <GridItem xs={12} sm={12} md={6}>
                    <Card login className={classes[cardAnimaton]}>
                        <CardHeader
                            className={`${classes.cardHeader} ${classes.textCenter}`}
                            color="rose"
                        >
                            <h4 className={classes.cardTitle}>ความมั่นคงปลอดภัยทางไซเบอร์</h4>
                        </CardHeader>

                        <CardBody style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '15px' }}>
                            {/* รูปภาพจากส่วนเนื้อหาหลักของโปสเตอร์ 4Do 4Don't */}
                            <img 
                                src={Do4Dont} 
                                style={{ width: "100%", maxHeight: "390px", objectFit: "contain" }} 
                                alt="Cyber Security Poster 4Do 4Don't" 
                            />
                        </CardBody>

                        <CardFooter>
                            {/* ปุ่มลิงก์รายละเอียดนโยบายด้านล่างสุด */}
                            <Button 
                                color="rose" 
                                size="md" 
                                block 
                                onClick={() => window.open("https://www.trangskin.go.th/cyber-policy/", "_blank")}
                            >
                                นโยบายและแนวปฏิบัติด้านสารสนเทศโดยละเอียด
                            </Button>
                        </CardFooter>
                    </Card>
                </GridItem>
              
            </GridContainer>
        </div>
    );
}
export default LoginPage;